import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import React from 'react'

function CompletedList(props: SvgIconProps) {
  return (
    <SvgIcon
      fill="none"
      height="128"
      viewBox="0 0 160 128"
      width="160"
      {...props}
    >
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="CompletedList-paint0_linear_310_7259"
          x1="37.9492"
          x2="124.609"
          y1="-5.53566"
          y2="98.2633"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F4F7FE" />
        </linearGradient>

        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="CompletedList-paint1_linear_310_7259"
          x1="52.2202"
          x2="106.78"
          y1="47.75"
          y2="79.25"
        >
          <stop stopColor="#00C853" />
          <stop offset="1" stopColor="#C8E6C9" />
        </linearGradient>
      </defs>
      <path
        d="M0.00576568 44.7858C-0.234619 30.1191 7.04867 15.6358 20.5353 11.6793C47.3005 3.82616 56.3741 22.6886 87.2725 6.58597C102.101 -1.14375 116.244 -1.08391 126.261 1.76565C137.481 4.95551 145.119 11.3203 151.376 19.7979C177.682 55.4324 136.551 71.6771 124.349 87.2038C117.859 95.4646 111.132 110.89 98.6567 119.768C79.1568 133.646 59.187 128.208 42.6973 116.515C30.4377 107.82 19.9971 94.941 12.0286 80.6558C3.64741 65.6339 0.152867 53.9328 0.00576568 44.7858Z"
        fill="url(#CompletedList-paint0_linear_310_7259)"
      />

      <path
        clipRule="evenodd"
        d="M52.2202 47.75C43.5413 62.7823 48.6609 81.9946 63.6484 90.7211L63.8517 90.8385C78.9028 99.4548 98.1009 94.2823 106.78 79.25C115.478 64.1837 110.316 44.9187 95.25 36.2202C80.1837 27.5217 60.9187 32.6837 52.2202 47.75Z"
        fill="url(#CompletedList-paint1_linear_310_7259)"
        fillRule="evenodd"
      />

      <path
        clipRule="evenodd"
        d="M73.2939 77.5402L63.3742 67.8283C62.4444 66.9179 62.4286 65.4259 63.339 64.496C64.2496 63.5657 65.7417 63.5504 66.6715 64.4605L73.2318 70.8835L93.1383 50.651C94.0514 49.7234 95.543 49.7113 96.4706 50.6239C97.3985 51.5367 97.4106 53.0288 96.498 53.9562L73.2939 77.5402Z"
        fill="white"
        fillRule="evenodd"
      />
    </SvgIcon>
  )
}

export default CompletedList
